import React from 'react'

const LogoIMG = ({ src }) => (
  <div className="logo-img-container">
    <img src={src} alt="" />
  </div>
)

export default LogoIMG
